import { callApi } from '@/_core/api/apiWrapper'
import Subject from '@/models/Subject'

export const getSubjects = async () => {
  const response = await callApi({
    method: 'get',
    url: 'subjects-reference/'
  })
  if (response.data) response.data.results = response.data.results.map(el => new Subject(el))
  return response
}
